import { useState } from "react";
import { MAX_FILE_SIZE, acceptedFileTypes } from "@/config/app";
import { getFileSize } from "@/utils";
import { ReactComponent as RiDeleteBinLine } from '@/assets/icons/ri-delete-bin-line.svg';
import { ReactComponent as RiCheckmarkLine } from '@/assets/icons/ri-checkmark-line.svg'
import Button from "@/components/common/Button";
import FileInput from "@/components/common/FileInput";



const getFileUrl = (fileInput: File) => URL.createObjectURL(fileInput);
const InputPhoto = ({ file, setFile, onSubmit }) => {
	const [title, setTitle] = useState<string>("");
	const [desc, setDesc] = useState<string>("");

	const handleChangeFile = (fileInput?: File) => {
		if (fileInput && fileInput.size < MAX_FILE_SIZE) {
			setFile(fileInput);
            setTitle(fileInput.name.replace(/\.[^/.]+$/, ""))
		}
	};

	return (
		<>
            {file == null && (
                <FileInput
                    classNames="mt-2 min-h-[200px] w-[300px]"
                    setFile={handleChangeFile}
                    accept={acceptedFileTypes}
                />
                    
            )}
			{file && (
				<div className="grid grid-flow-col auto-cols-max gap-4">
					<div className="gap-2 my-4">
						<img
							src={getFileUrl(file)}
							alt=""
							className="rounded overflow-hidden h-[170px] w-[300px] object-cover"
						/>
                        <div className="text-jsm font-normal text-grey-dark">
                            {getFileSize(file.size)}
                        </div>
					</div>
                    <div className="gap-2 m-4">
                        <p className="text-jsm font-normal text-grey-dark">
                            Title
                        </p>
                        <input
                            className="gap-2 items-center w-[300px] h-fit border border-grey-line-subtle rounded p-2 text-sm"
                            name="title"
                            type="text"
                            placeholder="Title"
                            value={title}
                            onChange={(e) => {
                                setTitle(e.target.value)
                            }}
                        />
                        <p className="text-jsm font-normal text-grey-dark pt-4">
                            Description
                        </p>
                        <textarea
                            className="gap-2 items-center w-[300px] h-fit border border-grey-line-subtle rounded p-2 text-sm"
                            name="description"
                            placeholder="Description"
                            value={desc}
                            onChange={(e) => {
                                setDesc(e.target.value)
                            }}
                        />
                    </div>
                    <div className="flex flex-grow-0 gap-7 items-center">
                        <div className="bg-grey-line-subtle h-6 w-0.5"/>
                        <Button
                            onClick={() => setFile(null)}
                            type="button"
                            className="text-red-primary flex items-center p-0 hover:cursor-pointer">
                            <RiDeleteBinLine />
                        </Button>
                        <Button
                            onClick={() => {
                                const photo: PhotoPayload = {
                                    title,
                                    file,
                                    is_show : true,
                                    description : desc
                                }
                                onSubmit(photo)
                            }}
                            type="button"
                            className="text-green-success flex items-center p-0 hover:cursor-pointer"
                            >
                            <RiCheckmarkLine />
                        </Button>
                    </div>
				</div>
			)
            
            }
		</>
	);
};

export default InputPhoto
